/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Note_Col_ItemsInputs */

const vi_pl_note_col_items = /** @type {(inputs: Pl_Note_Col_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số dòng`)
};

/**

* @param {Pl_Note_Col_ItemsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_note_col_items = /** @type {((inputs?: Pl_Note_Col_ItemsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Note_Col_ItemsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_note_col_items(inputs)
});